import { token } from '@atlaskit/tokens';

export const overrideMarks = ['backgroundColor'];

export const DEFAULT_COLOR = {
	color: token('color.text'),
	label: 'Default',
};
